import React from "react";
import { isPortalTestEnvironment } from "../utils/environmentMode";

const LIVE_PORTAL_URL = "https://ecotourodisha.com";

const TestEnvironmentOverlay = () => {
  const [isMobileDismissed, setIsMobileDismissed] = React.useState(false);

  if (!isPortalTestEnvironment()) return null;
  if (isMobileDismissed) return null;

  return (
    <div className="test-env-banner" aria-live="polite">
      <div className="test-env-banner__content">
        <div className="test-env-banner__copy">
          <div className="test-env-banner__eyebrow">This Is A Test Site</div>
          <div className="test-env-banner__message">No payment will be valid here</div>
        </div>
        <a className="test-env-banner__link" href={LIVE_PORTAL_URL}>
          Main site
        </a>
      </div>
      <button
        type="button"
        className="test-env-banner__close"
        onClick={() => setIsMobileDismissed(true)}
        aria-label="Close test site warning"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  );
};

export default TestEnvironmentOverlay;
